module.exports = __webpack_public_path__ + "static/media/roble_rustico.78ac5627.jpg";